var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2 31.6C8.55281 31.6 6.40003 33.7528 6.40003 36.4C6.40003 39.0472 8.55281 41.2 11.2 41.2C13.8473 41.2 16 39.0472 16 36.4C16 33.7528 13.8472 31.6 11.2 31.6ZM11.2 39.6C9.43519 39.6 8.00006 38.1648 8.00006 36.4C8.00006 34.6352 9.43528 33.2001 11.2 33.2001C12.9648 33.2001 14.4 34.6353 14.4 36.4C14.4 38.1648 12.9648 39.6 11.2 39.6Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4 31.6C35.7528 31.6 33.6 33.7528 33.6 36.4C33.6 39.0472 35.7528 41.2 38.4 41.2C41.0472 41.2 43.2 39.0472 43.2 36.4C43.2 33.7528 41.0472 31.6 38.4 31.6ZM38.4 39.6C36.6352 39.6 35.2 38.1648 35.2 36.4C35.2 34.6352 36.6352 33.2001 38.4 33.2001C40.1648 33.2001 41.6 34.6353 41.6 36.4C41.6 38.1648 40.1648 39.6 38.4 39.6Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8728 27.1672L40.6728 15.9672C40.5256 15.7384 40.272 15.6 39.9999 15.6H31.2C30.7576 15.6 30.4 15.9584 30.4 16.4V36.3999C30.4 36.8423 30.7576 37.1999 31.2 37.1999H34.4V35.5999H32V17.2H39.5632L46.4 27.8352V35.6001H42.3999V37.2H47.1999C47.6423 37.2 47.9999 36.8424 47.9999 36.4V27.6C48 27.4472 47.956 27.296 47.8728 27.1672Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2 26V20.4H41.6001V18.8H34.4001C33.9577 18.8 33.6001 19.1584 33.6001 19.5999V26.7999C33.6001 27.2423 33.9577 27.5999 34.4001 27.5999H46.4001V25.9999H35.2V26Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2 10H0.799969C0.358406 10 0 10.3584 0 10.8V36.4C0 36.8424 0.358406 37.2 0.799969 37.2H7.2V35.6H1.60003V11.6H30.4V35.6H15.2V37.2H31.2C31.6424 37.2 32 36.8424 32 36.4V10.8C32 10.3584 31.6424 10 31.2 10Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.59997 32.4H0.799969V34H5.59997V32.4Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4 32.4H16.8V34H30.4V32.4Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1999 32.4H44V34H47.1999V32.4Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2 13.2H3.19997V14.8H31.2V13.2Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12 35.6H10.4V37.2H12V35.6Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2001 35.6H37.6V37.2H39.2001V35.6Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 6.79997H3.19997V8.4H14.4V6.79997Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1.60003 6.79997H0V8.4H1.60003V6.79997Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.428d24ef24ab08796470ac31fd5b5b67.svg";
export { ForwardRef as ReactComponent };